import { IQueryGetEntitiesFieldArgs } from './types';
import { graphql } from '../gql';
import { toPagination } from './utils';
import { useQuery } from '@apollo/client';

export const GET_ENTITIES_COVERAGES = graphql(`
  query getCoverages(
    $pagination: PaginationRequest
    $uuid: String
    $entityUuid: String
  ) {
    entities(
      filters: {
        submissionUuid: $uuid
        submissionType: INSURED
        entityUuid: $entityUuid
      }
      pagination: $pagination
    ) {
      pageInfo {
        totalResults
        pageNumber
        pageSize
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          coverages(
            filters: { submissionUuid: $uuid, entityUuid: $entityUuid }
            sort: { key: "order", order: "ASC" }
          ) {
            edges {
              cursor
              node {
                uuid
                name
                type
                score
                order
                minScore
                maxScore
                controls {
                  edges {
                    cursor
                    node {
                      uuid
                      name
                      type
                      referenceId
                      description
                      score
                      minScore
                      maxScore
                      excluded
                      subControls {
                        edges {
                          cursor
                          node {
                            uuid
                            name
                            type
                            referenceId
                            description
                            score
                            minScore
                            maxScore
                            excluded
                            questions {
                              edges {
                                node {
                                  uuid
                                  question
                                  type
                                  answer {
                                    uuid
                                    answer
                                    type
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useGetEntitiesCoveragesQuery({
  submissionUuid,
  pageNumber,
  pageSize,
  entityUuid,
}: IQueryGetEntitiesFieldArgs) {
  const { loading, error, data, refetch } = useQuery(GET_ENTITIES_COVERAGES, {
    variables: {
      uuid: submissionUuid,
      pagination: toPagination(pageNumber, pageSize),
      entityUuid: entityUuid,
    },
    fetchPolicy: 'no-cache',
  });

  return {
    error,
    loading,
    data,
    refetch,
  };
}
